import { render } from "./BoardFilter.vue?vue&type=template&id=998d2b7a&scoped=true"
import script from "./BoardFilter.vue?vue&type=script&lang=js"
export * from "./BoardFilter.vue?vue&type=script&lang=js"

import "@/styles/common.css?vue&type=style&index=0&id=998d2b7a&scoped=true&lang=css"
import "@/styles/subcommon.css?vue&type=style&index=1&id=998d2b7a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-998d2b7a"]])

export default __exports__